import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import StyledButton from "../StyledButton";
import { styled } from "@mui/material/styles";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import FolderIcon from "@mui/icons-material/Folder";
import sampleFile from "../../../src/assets/images/profilecreate.csv";
import { toast } from "react-toastify";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import "react-toastify/dist/ReactToastify.css";
import LinearProgress from "@mui/material/LinearProgress";
import Papa from "papaparse";
import { useParams } from "react-router-dom";
import { Button, Menu, MenuItem, Stack, IconButton } from "@mui/material";
import * as XLSX from "xlsx"; // ✅ NEW

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
  },
  "& .MuiPaper-root": {
    borderRadius: "15px",
    padding: theme.spacing(1),
  },
  "& .MuiTypography-root": {
    fontWeight: 700,
  },
}));

const ProfileUploadDialogCopy = ({ reload }) => {
  const [open, setOpen] = useState(false);
  const [fileData, setFileData] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [cardTypes, setCardTypes] = React.useState([]);
  const { id } = useParams();

  // ✅ UPDATED ACCEPT TYPES
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "text/csv": [".csv"],
      "application/vnd.ms-excel": [".csv"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
    },
    maxFiles: 1,
    onDrop: (files) => setFileData(files),
  });

  const navigate = useNavigate();

  const handleClickOpen = () => setOpen(true);

  const handleClose = () => {
    setFileData([]);
    setOpen(false);
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClickMenu = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  useEffect(() => {
    fetchCardTypes();
  }, []);

  const fetchCardTypes = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        navigate("/sign-in");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/v1/api/admin/getCardTypes`,
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
// console.log(response.data);
      if (response.status === 200) {
        setCardTypes(response.data.cards);
      }
    } catch (error) {
      console.error("Error fetching card types:", error);
    }
  };

  // ✅ FUNCTION TO CONVERT XLSX → CSV
  const convertXlsxToCsv = async (file) => {
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data, { type: "array" });

    const sheetName = workbook.SheetNames[0]; // first sheet
    const worksheet = workbook.Sheets[sheetName];

    const csv = XLSX.utils.sheet_to_csv(worksheet);
    return csv;
  };

  const handleSubmit = async () => {
    const authToken = localStorage.getItem("authToken");

    if (!authToken) {
      navigate("/sign-in");
      return;
    }

    if (fileData.length <= 0) {
      toast.error("Please add the data", { autoClose: 2000 });
      return;
    }

    setUploading(true);

    const file = fileData[0];
    let csvData = "";

    try {
      // ✅ CHECK FILE TYPE
      if (file.name.endsWith(".xlsx")) {
        csvData = await convertXlsxToCsv(file);
      } else {
        // CSV case
        csvData = await file.text();
      }

      // Validate CSV
      const parsedData = Papa.parse(csvData, { header: true });
      const totalRows = parsedData.data.length;

      if (totalRows === 0) {
        toast.error("File is empty or invalid", { autoClose: 2000 });
        setUploading(false);
        return;
      }

      // Send CSV to backend
      const formData = new FormData();
      formData.append("orderId", id);
      formData.append("file", new Blob([csvData], { type: "text/csv" }));
      // console.log("formData to be sent:", formData);
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/v1/api/admin/bulk-activation`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("Success! All Data uploaded successfully", {
        autoClose: 2000,
      });

      handleClose();
      reload();
    } catch (error) {
  console.error("Upload error:", error);

  if (error.response?.data) {
    const data = error.response.data;

    // ✅ 1. Show main backend message FIRST
    if (data.message) {
      toast.error(data.message);
    }
  } else {
    toast.error("Network error or server not reachable");
  }
} finally {
      setUploading(false);
      setUploadProgress(0);
    }
  };

  const handleCopy = (cardName) => {
    navigator.clipboard.writeText(cardName);
    toast.success(`${cardName} copied!`);
  };

  return (
    <div>
      <StyledButton text={"Bulk Profile Creation"} onClick={handleClickOpen} />

      <BootstrapDialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Bulk Profile Creation</DialogTitle>

        <DialogContent>
          <section className="container">
            <Stack direction="row" justifyContent="space-between">
              <a href={sampleFile} download="sampleprofilecreation.csv">
                Download sample import file
              </a>

              <Stack>
                <Button onClick={handleClickMenu}>Card Styles</Button>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                >
                  {cardTypes.map((card) => (
                    <MenuItem key={card.id}>
                      {card.name}
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCopy(card.name);
                        }}
                      >
                        <ContentCopyIcon fontSize="small" />
                      </IconButton>
                    </MenuItem>
                  ))}
                </Menu>
              </Stack>
            </Stack>

            <div
              {...getRootProps()}
              style={{
                border: "2px dashed #aaa",
                padding: "0 25%",
                height: "100px",
                margin: "10px 0",
                borderRadius: "10px",
                backgroundColor: "#eee",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <input {...getInputProps()} />
              <p>Select CSV or Excel (.xlsx) file</p>
            </div>

            {fileData.length > 0 && (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>
                  <FolderIcon /> {fileData[0].name}
                </span>
                <StyledButton
                  text={"Delete"}
                  onClick={() => setFileData([])}
                />
              </div>
            )}
          </section>
        </DialogContent>

        {uploading && <LinearProgress />}

        <DialogActions>
          <StyledButton text={"Cancel"} onClick={handleClose} />
          <StyledButton
            text={uploading ? "Uploading..." : "Upload"}
            onClick={handleSubmit}
            disabled={uploading}
          />
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default ProfileUploadDialogCopy;